const setDate = date => {
  date = new Date(date || Date.now())

  return date
}

const formatDate = (date, format) => {
  return setDate(date).toLocaleDateString('en-US', format)
}

const weekday = date => formatDate(date, {
  weekday: 'short'
})

const monthDay = date => formatDate(date, {
  month: 'short',
  day: 'numeric'
})

const longDate = date => formatDate(date, {
  month: 'long',
  day: 'numeric',
  year: 'numeric'
})

const shortISO = date => {
  const y = formatDate(date, {
    year: 'numeric'
  }).toString().padStart(4, '0')
  const m = formatDate(date, {
    month: 'numeric'
  }).toString().padStart(2, '0')
  const d = formatDate(date, {
    day: 'numeric'
  }).toString().padStart(2, '0')
  return `${y}-${m}-${d}`
}

export { weekday, monthDay, longDate, shortISO }
